var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClaimManagement = function SvgClaimManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    strokeWidth: 4,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#claimManagement_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "claimManagement_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 0H0v24h24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#claimManagement_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.39 14.81 23 17l-2.195-4.6a7.45 7.45 0 0 0-1.162-9.314 7.48 7.48 0 0 0-6.233-2.012 7.49 7.49 0 0 0-5.429 3.66 7.45 7.45 0 0 0-.95 2.875"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.6 7.322a7.62 7.62 0 0 0-4.34-.013 7.65 7.65 0 0 0-3.648 2.358 7.706 7.706 0 0 0-1.13 8.276L1 23l5.68-1.557a7.6 7.6 0 0 0 1.585.684 7.66 7.66 0 0 0 5.786-.694 7.7 7.7 0 0 0 3.638-4.57 7.74 7.74 0 0 0-.6-5.817 7.7 7.7 0 0 0-4.495-3.723z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 12.875a1.875 1.875 0 1 1 1.875 1.875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M10.5 18.375a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "claimManagement_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgClaimManagement;